import { render, staticRenderFns } from "./WidgetFormTable.vue?vue&type=template&id=9339f824&"
import script from "./WidgetFormTable.vue?vue&type=script&lang=js&"
export * from "./WidgetFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports